module.exports = __webpack_public_path__ + "static/media/strutture-transenne-calcetto-noleggiocampi.d482854e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/strutture-di-contenimento/transenne/slider1/strutture-transenne-calcetto-noleggiocampi.jpg
// module id = 669
// module chunks = 0